//! вывод годов в фильтр от 2025 и далее по факту наступления след года
export const years = generateYears(2025, new Date().getFullYear());

function generateYears(fromYear: number, toYear: number) {
  const years = [];
  for (let year = fromYear; year <= toYear; year++) {
    years.push({ ID: year, Title: String(year) });
  }
  return years;
}

export const filterConfigReportAction = {
  year: {
    title: 'Год',
    hasSearch: false,
    searchPlaceholder: 'Поиск по году',
    options: years.map((item) => item.Title),
  },

  columnReportAction: {
    title: 'Колонна',
    options: [],
    searchPlaceholder: 'Найти колонну',
  },
  groupReportPeriod: {
    title: 'Группа',
    hasSearch: true,
    searchPlaceholder: 'Поиск по группе',
    options: [],
  },
  factoryReport: {
    title: 'Завод',
    hasSearch: true,
    searchPlaceholder: 'Поиск по заводу',
    options: [],
  },
  department: {
    title: 'Отдел',
    hasSearch: true,
    searchPlaceholder: 'Поиск по отделу',
    options: [],
  },
};

const getCurrentDate = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return {
    year: {
      id: currentYear,
      name: currentYear.toString(),
    },
  };
};

const currentDate = getCurrentDate();

export const initialFilterReportAction = {
  year: {
    selected: [currentDate.year.name],
    selectedIds: [currentDate.year.id],
    search: '',
  },

  columnReportAction: { selected: ['Менеджмент'], selectedIds: [22], search: '' },
  factoryReport: { selected: [], selectedIds: [], search: '' },
  groupReportPeriod: { selected: ['VOP'], selectedIds: [1279], search: '' },
  department: { selected: [], selectedIds: [], search: '' },
};

export const filtersOpenReportAction = {
  year: false,

  columnReportAction: false,
  factoryReport: false,
  groupReportPeriod: false,
  department: false,
};
